import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { TtCompanyReport } from "@/CodegenTypes";
import { first } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { negateNumber } from "@/helpers/negateNumber";
import { computed } from "vue";
import { useRoute } from "vue-router/composables";
import { useQuery } from "@vue/apollo-composable";
import CompanyPlTable from "@/components/modules/report/CompanyPlTable.vue";
import { useTranslation } from "@/store/translation";
import { FEATURE_TOGGLES } from "@/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyPLReportLegacy',
  setup(__props) {

const { $t } = useTranslation();
const route = useRoute()

const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const selectedEndReleaseDate = computed(() => {
  const query = route.query.endReleaseDate;
  return Array.isArray(query) ? first(query) : query;

})

const ttCompanyReportQuery = FEATURE_TOGGLES.useV1Legacy
  ? queries.ttCompanyReportLegacy
  : queries.ttCompanyReport;

const { result, loading } = useQuery<{ ttCompanyReport: TtCompanyReport }>(ttCompanyReportQuery, {
  releaseDateStart: selectedStartReleaseDate,
  releaseDateEnd: selectedEndReleaseDate,
}, {
  fetchPolicy: "cache-and-network",
})

const companyPlStatement = computed(() => {
  return result.value?.ttCompanyReport.companyTicketsFinal.summary;
})


return { __sfc: true,$t, route, selectedStartReleaseDate, selectedEndReleaseDate, ttCompanyReportQuery, result, loading, companyPlStatement, formatDollar, negateNumber, CompanyPlTable }
}

})